<div class="sidebar-reference-reminders"><app-loading [isLoading]="isLoading">
  @if (!settings?.settings_json?.auto_reminders?.is_enabled) {
    <div class="alert alert-warning small fadeIn">{{ 'SIDEBAR.WARNING.AUTO_REMINDERS' | translate }}</div>
  }
  <div class="card v-card mt-2 mb-4 fadeIn">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-10">
          <h5 class="card-title">{{ ('SIDEBAR.REMINDERS.TITLE' | translate) | titlecase }}</h5>
          <h6 class="card-subtitle text-muted small">{{ 'SIDEBAR.REMINDERS.DESCRIPTION' | translate : { fullName: reference.full_name } }}</h6>
        </div>
        <div class="col-12 col-md-2 align-items-center d-flex">
          <div class="btn-toolbar ms-auto me-0"><ui-switch [(ngModel)]="reference.is_reminders_enabled" (change)="patch('is_reminders_enabled')"></ui-switch></div>
        </div>
      </div>
    </div>
    </div><app-table [cols]="cols" [rows]="rows" [onButtonClick]="onButtonClick"></app-table>
  </app-loading></div>
